import HomePage from "./HomePage";
import LoginPage from "./LoginPage";
import NotFoundPage from "./NotFoundPage";

const pages = [
  {
    name: "home",
    path: "/",
    component: HomePage,
  },
  {
    name: "login",
    path: "/login",
    component: LoginPage,
  },
  {
    name: "404",
    path: "/404",
    component: NotFoundPage,
  },
];

export default pages;
